import React from 'react';
import { oneOfType, string, node } from 'prop-types';


const IEErrorMessage = ({ message }) => {
  if (!message) {
    return null;
  }
  return (
    <div className="ie--error">
      <div className="ie--error--message">
        {message}
      </div>
    </div>
  );
};

IEErrorMessage.propTypes = {
  message: oneOfType([
    string,
    node,
  ]),
};

export default IEErrorMessage;
